export const REFUND_REASONS: { label: string; value: string }[] = [
  { label: "Phone disconnected", value: "Disconnected Phone" },
  {
    label: "Home already listed on MLS (provide MLS number in comments)",
    value: "Listed for sale on the MLS",
  },
  { label: "Other", value: "Other" },
];
